interface MoveContentProps {
  movementRef: React.RefObject<HTMLElement>;
  complementsRef?: React.MutableRefObject<HTMLElement | null>;
  newQuantity: number;
  setComplementBlockIsUp: React.Dispatch<React.SetStateAction<boolean>>;
}

interface MoveUpProps {
  movementSection: HTMLElement;
  complementsSection: HTMLElement;
  setComplementBlockIsUp: React.Dispatch<React.SetStateAction<boolean>>;
}

export const moveUp = ({ complementsSection, movementSection, setComplementBlockIsUp }: MoveUpProps) => {
  const dividerBeforeCssStyle = window.getComputedStyle(complementsSection, '::before');
  const dividerSize =
    parseFloat(dividerBeforeCssStyle.marginBottom) + parseFloat(dividerBeforeCssStyle.borderWidth);

  const pureComplementsHeight = complementsSection.clientHeight - Math.round(dividerSize);
  const miscHeight = movementSection.clientHeight + Math.round(dividerSize / 2);

  complementsSection.style.transform = `translateY(-${miscHeight}px)`;
  movementSection.style.transform = `translateY(${pureComplementsHeight}px)`;

  setComplementBlockIsUp(true);
};

export const moveContent = async ({
  movementRef,
  complementsRef,
  newQuantity,
  setComplementBlockIsUp,
}: MoveContentProps) => {
  const complementsSection = complementsRef?.current;
  const movementSection = movementRef?.current;

  if (!complementsSection || !movementSection) return;

  if (newQuantity > 0) {
    moveUp({ complementsSection, movementSection, setComplementBlockIsUp });
  } else if (newQuantity === 0) {
    complementsSection.style.transform = `translateY(0px)`;
    movementSection.style.transform = `translateY(0px)`;
    setComplementBlockIsUp(false);
  }
};
